import Modal, { ModalSize } from 'lib/Modal';
import { TableHeight } from 'lib/Table/Table.types';
import { FrameTag } from 'components/common/types/FrameTag.types';

import tagSvg from 'assets/icons/tag.svg';

import { TaggingRulesTable } from '../TaggingRulesTable/TaggingRulesTable';

interface Props {
  frameTags: FrameTag[];
  onClose: VoidFunction;
  isOpen: boolean;
  marketId: string;
}

export const TaggingRulesModal: React.FC<Props> = ({ isOpen = false, onClose, frameTags, marketId }) => {
  return (
    <Modal isOpen={isOpen} size={ModalSize.LARGE} icon={tagSvg} title="Frame tagging rules" onClose={onClose}>
      <TaggingRulesTable frameTags={frameTags} tableHeight={TableHeight.NORMAL} marketId={marketId} />
    </Modal>
  );
};
